import * as Yup from "yup"

export default function validation_form_end_time(field, acc) {
  const { field_name } = field

     Yup.addMethod(Yup.date, "positiveFormLegth", function (errorMessage) {
      return this.test(`positive-form-length`, errorMessage, function (value) {
        const { path, createError } = this
        return (
          createError({ path, message: errorMessage })
        )
      })
    })

  return {
    
    [field_name]: Yup.date().when("form_length", {
      is: (value) => {
        return  value <= 0
      }, 
      then: Yup.date().positiveFormLegth('End time must be later than the start time.')
      .required("Required"),
    }),
    ...acc,
  }
}

